export default {"src":"/_next/static/media/assessment-and-feedback.cbbf0801.svg","height":252,"width":252,"blurWidth":0,"blurHeight":0};